import { FC } from 'react';
// Modules
import { wrapper } from 'app/redux/store/store';
import { AppProps } from 'next/app';
// MUI Core
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from '@material-ui/core/styles';
// Utils
import theme from '@layout/theme';
import AlertNotification from '@module/alert';
import HeadMetaTags from '@module/headMetaTags';
import Loader from '@module/loader';
import '@styles/app.scss';
import Router from 'next/router';
import NProgress from 'nprogress'; //nprogress module
import ErrorBoundary from './ErrorBoundary';

//Binding events. 
NProgress.configure({ showSpinner: false });
Router.events.on('routeChangeStart', () => NProgress.start());
Router.events.on('routeChangeComplete', () => NProgress.done());
Router.events.on('routeChangeError', () => NProgress.done());

const WrappedApp: FC<AppProps> = ({ Component, pageProps }: any) => {

  return (
    <ThemeProvider theme={theme}>
      <ErrorBoundary>
        <HeadMetaTags {...pageProps.metaTags} storeData={pageProps.storeData} />
        <CssBaseline />
        <Loader />
        <AlertNotification />
        <Component {...pageProps} />
      </ErrorBoundary>
    </ThemeProvider>
  );
}

export default wrapper.withRedux(WrappedApp);

export function reportWebVitals(metric) {
  // console.log('Largest Contentful Paint', metric)
}
